module.exports = __webpack_public_path__ + "static/img/luckDraw.0b67ddc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integral/luckDraw.gif?v=1
// module id = ymGX
// module chunks = 1